import * as React from 'react';
import Spinner from './Spinner';
import { cx } from '@/lib/ui';

type LoadingStateProps = {
  message?: React.ReactNode;
  detail?: React.ReactNode;
  compact?: boolean;
  className?: string;
};

export default function LoadingState({
  message = 'Loading…',
  detail,
  compact = false,
  className,
}: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cx(
        'flex items-center text-slate-600',
        compact
          ? 'gap-2 text-sm'
          : 'min-h-32 justify-center gap-3 rounded-aula-lg border border-aula-border bg-white p-6 shadow-aula-card',
        className
      )}
    >
      <Spinner className={compact ? 'h-4 w-4' : 'h-5 w-5'} />
      <div>
        <div className="font-semibold text-slate-700">{message}</div>
        {detail ? <div className="mt-0.5 text-xs text-slate-500">{detail}</div> : null}
      </div>
    </div>
  );
}

export function AulaLoadingState({
  message = 'Aulaing…',
  ...props
}: LoadingStateProps) {
  return <LoadingState message={message} {...props} />;
}

export const aulaLoadingCopy = {
  prompt: 'Aulaing your prompt…',
  lesson: 'Aulaing your lesson…',
  game: 'Aulaing your game…',
  assessment: 'Aulaing your assessment…',
  results: 'Aulaing your results…',
} as const;
